import React, { useEffect } from "react";
import TickIcon from "../../../../../components/Common/SvgIcons/ManageIcons/TickIcon";
import { FormProvider, useForm } from "react-hook-form";
import { addGroupTopic } from "../../../../../utils/mainTabs/organize/addGroupTopic";
import Button from "../../../../../components/Common/Button/Button";
import { useNavigate, useOutletContext } from "react-router";
import { addGroupTopicActionHandler } from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import classes from "./PublishGroupTopic.module.scss";
import { useDispatch } from "react-redux";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import { topicManagement } from "../../../../../utils/mainTabs/organize/topicManagement";

const PublishGroupTopic = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { formData, setFormData, dataForUpdateGroupTopicByID, tenantName } =
    useOutletContext();
  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      ...formData.details,
      ...formData.topicContent,
    },
  });

  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    watch,
    setValue,
  } = methods;
  const clearAll = () => {
    reset();
  };
  const onSubmit = (data) => {};
  useEffect(() => {
    setTimeout(() => {
      navigate(`${topicManagement.path(tenantName)}`);
    }, 5000);
  }, []);
  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.publisheMain}>
          <div className={classes.body}>
            <TickIcon fill={"#0da812"} />
            Topic has been
            {`${
              dataForUpdateGroupTopicByID?.[0]?.IsPublished
                ? " UnPublished "
                : " Publish "
            }`}
            Successfully.
            <div className={classes.linkRedirect}>
              You will be redirected to Topic automatically after 5 sec
            </div>
          </div>
          <div className={classes.footer}>
            {/* <div
              className={classes.clearAll}
              onClick={() => navigate(`${addGroupTopic.path}/topicContent`)}
            >
              Cancel
            </div>
            <Button
              label="Publish"
              type="submit"
              name="publishbtn"
              small
              dark
              onClick={setValue("publishbtn", true)}
            /> */}
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default PublishGroupTopic;
